import { Actions } from '@components/core-ui/UniversalCard/components/Actions';

import { TProps } from './types/TProps';

const wrapperClassName = 'col-span-1 flex h-[72px] rounded-[5px]';

const cardClassName =
  'card flex flex-1 items-center justify-between whitespace-nowrap rounded-[5px] bg-[var(--color-surface)]';

const cardTextClassName =
  'card-text flex w-[180px] flex-1 flex-col justify-center overflow-hidden text-ellipsis whitespace-nowrap px-5 py-2.5 text-sm leading-5 [&_p]:overflow-hidden [&_p]:text-ellipsis [&_p]:whitespace-nowrap';

const noActionsClassName = 'shrink-0 pb-[25px] pr-2.5';

export const UniversalNoPictureCard = ({ content, actions, className = 'universal-card' }: TProps) => {
  return (
    <div className={[wrapperClassName, className].filter(Boolean).join(' ')}>
      <div className={cardClassName}>
        <div className={cardTextClassName}>{content}</div>
        {actions?.length ? <Actions actions={actions} /> : <div className={noActionsClassName} />}
      </div>
    </div>
  );
};
